import axios from "axios";

export const CLE = "prof_session";
export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/prof` });
api.interceptors.request.use((config) => {
  const jeton = localStorage.getItem(CLE);
  if (jeton) config.headers.Authorization = `Bearer ${jeton}`;
  // Le journal de la console dit si un changement vient de l'app installée ou du site.
  const installee = window.matchMedia?.("(display-mode: standalone)").matches
    || window.navigator.standalone === true;
  config.headers["X-App-Mode"] = installee ? "app" : "navigateur";
  return config;
});
export const erreurDe = (e) => e?.response?.data?.detail || e?.message || "Une erreur est survenue.";

export const JOURS = ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"];
export const MOIS = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août",
  "septembre", "octobre", "novembre", "décembre"];
export const iso = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export const aujourdhui = () => iso(new Date());
export const decaler = (j, n) => { const d = new Date(`${j}T12:00:00`); d.setDate(d.getDate() + n); return iso(d); };
export const jourLisible = (j) => {
  const d = new Date(`${j}T12:00:00`);
  return `${JOURS[d.getDay()]} ${d.getDate()} ${MOIS[d.getMonth()]}`;
};
export const jourCourt = (j) => {
  const d = new Date(`${j}T12:00:00`);
  return `${JOURS[d.getDay()].slice(0, 3)}. ${d.getDate()}.${String(d.getMonth() + 1).padStart(2, "0")}`;
};
/** « Mardi 3 novembre » : la classe CSS « capitalize » écrivait « Mardi 3 Novembre ». */
export const majuscule = (t) => { const s = String(t || ""); return s.charAt(0).toUpperCase() + s.slice(1); };
export const chf = (n) => `CHF ${Number(n || 0).toFixed(2)}`;
export const moisCourant = () => aujourdhui().slice(0, 7);
export const decalerMois = (m, n) => {
  const [a, mm] = m.split("-").map(Number);
  const d = new Date(a, mm - 1 + n, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};
export const moisLisible = (m) => { const [a, mm] = m.split("-").map(Number); return `${MOIS[mm - 1]} ${a}`; };
export const urlServeur = (chemin) => `${process.env.REACT_APP_BACKEND_URL}${chemin}`;
export const tel = (t) => `tel:${String(t || "").replace(/[^\d+]/g, "")}`;
/** Écrire un SMS (école, 30.10.2026 : par SMS, pas WhatsApp). */
export const sms = (t) => `sms:${String(t || "").replace(/[^\d+]/g, "")}`;

/** Lance `fn` une fois que l'utilisateur a fini de taper ou de cocher (sauvegarde auto). */
export const plusTard = (() => {
  const minuteries = {};
  return (cle, fn, ms = 700) => { clearTimeout(minuteries[cle]); minuteries[cle] = setTimeout(fn, ms); };
})();
